<ng-template #defaultTemplate let-item="item">
  <span>{{item}}</span>
</ng-template>
<ng-container *ngIf="inputItems?.length">
  <ng-container *ngIf="useList && inputItems.length > 1">
    <ul>
      <ng-container *ngFor="let item of inputItems; let firstItem = first; let lastItem = last; let index = index">
        <li *ngIf="(index < maxItems) || ((index >= maxItems) && expanded)">
          <ng-container *ngTemplateOutlet="inputTemplate || defaultTemplate;
        context:{item: item, firstItem: firstItem, lastItem: lastItem, expanded: expanded}"></ng-container>
        </li>
      </ng-container>
    </ul>
  </ng-container>
  <ng-container *ngIf="!useList || inputItems.length < 2">
    <ng-container *ngFor="let item of inputItems; let firstItem = first; let lastItem = last; let index = index">
      <ng-container *ngIf="(index < maxItems) || ((index >= maxItems) && expanded)">
        <ng-container *ngTemplateOutlet="inputTemplate || defaultTemplate;
        context:{item: item, firstItem: firstItem, lastItem: lastItem, expanded: expanded}"></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="inputItems.length > maxItems">
    <br *ngIf="breakLine">
    <a class="link body-3 medium align-right" (click)="expanded = !expanded">
      <span>{{ (expanded ? (expandStrings?.less || 'general.api_show_less') : (expandStrings?.more || 'general.api_show_more')) | translate }}
        <ng-container *ngIf="showCount && !expanded && inputItems?.length > maxItems">{{' (' + (inputItems.length - maxItems) + ')'}}</ng-container>
      </span>
    </a>
  </ng-container>
</ng-container>
